module.exports = "/images/Ice skating.svg?bff3d5bef643b2f64168ede3a65e99ea";